module.exports = __webpack_public_path__ + "static/img/carousel_2_klrq02_ar_16_9_w_2154.4cd1a7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_2_klrq02_ar_16_9_w_2154.jpg
// module id = sW2k
// module chunks = 0